import { useState, useEffect} from 'react';
import { getLocalStorageItem } from '../../components/global/storage';
import { API_GRAPHQL } from '../../constants';
import { axiosAuthFetch } from '../../helpers/axios';

export function useGetProgramsByCoachMetaOnly() {
  const user = getLocalStorageItem('limitless-user');
  const coachID = user.user.coachID;
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const query = `
        query {
          programs(
            pagination: { limit: 150 },
            filters: { created_by_coach: { id: { eq: ${coachID} } } }
          ) {
            data {
              id
              attributes {
                programName
                users{
                    data{
                        id
                    }
                }
                cover_image {
                  data {
                    attributes {
                      images {
                        data {
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      setIsLoading(true);
      setIsError(false);

      try {
        const response = await axiosAuthFetch(API_GRAPHQL, { query }, 'POST');
        setPrograms(response.data.programs.data);
      } catch (error) {
        console.error(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetch();
  }, [coachID]);

  return { programs, isLoading, isError };
}

export function useGetProgramsByCoach() {
    const user = getLocalStorageItem('limitless-user');
    const coachID = user.user.coachID;
    const url = API_GRAPHQL;
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [programs, setPrograms] = useState([]);

    useEffect(() => {
        async function getPrograms(url) {

            const query = `query {
                programs(
                    pagination: {limit: 10},
                    filters: {created_by_coach: {id:{eq:${coachID}}}}
                ) {
                    data{
                        id
                        attributes {
                            programName
                            Description
                            cover_image{
                                data{
                                    id
                                    attributes{
                                        images{
                                            data{
                                                id
                                                attributes{
                                                    url
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            pairs{
                                data{
                                    id
                                    attributes{
                                        description
                                        comment
                                        coach_comment
                                        exercise{
                                            data{
                                                id
                                                attributes{
                                                    name
                                                    image{
                                                        data{
                                                            id
                                                            attributes{
                                                                url
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            users{
                                data{
                                    id
                                    attributes{
                                        username
                                        profile_picture{
                                            data{
                                                id
                                                attributes{
                                                    url
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }`;
            ;
            try {
                setIsError(false);
                setIsLoading(false);

                const response = await axiosAuthFetch(url, { query }, 'post')
                console.log(response);
                setPrograms(response.data.programs.data);
            } catch(error) {
                console.error(error);
            }
            finally {
                setIsLoading(false);
            }
        }

        getPrograms(url)
    }, [coachID, url])

    return {programs, isLoading, isError};

}

export function useProgramDetails(programId) {
    const [program, setProgram] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    useEffect(() => {
      if (!programId) return;
  
    //   const query = `
    //     query {
    //       program(id: ${programId}) {
    //         data {
    //           id
    //           attributes {
    //             programName
    //             pairs {
    //               data {
    //                 id
    //                 attributes {
    //                   description
    //                   comment
    //                   coach_comment
    //                   exercise {
    //                     data {
    //                       id
    //                       attributes {
    //                         name
    //                         image {
    //                           data {
    //                             attributes {
    //                               url
    //                             }
    //                           }
    //                         }
    //                       }
    //                     }
    //                   }
    //                 }
    //               }
    //             }
    //             users {
    //               data {
    //                 id
    //                 attributes {
    //                   username
    //                   profile_picture {
    //                     data {
    //                       attributes {
    //                         url
    //                       }
    //                     }
    //                   }
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }`;

    const query = `
  query {
    program(id: ${programId}) {
      data {
        id
        attributes {
          programName
          pairs {
            data {
              id
              attributes {
                description
                comment
                coach_comment
                exercise {
                  data {
                    id
                    attributes {
                      name
                      image {
                        data {
                          id
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          users {
            data {
              id
              attributes {
                username
                profile_picture {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;
  
      const fetchProgram = async () => {
        setIsLoading(true);
        try {
          const res = await axiosAuthFetch(API_GRAPHQL, { query }, 'POST');
          setProgram(res.data.program.data);
        } catch (err) {
          console.error('Feil ved henting av programdetaljer:', err);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchProgram();
    }, [programId]);
  
    return { program, isLoading };
  }

export function useGetPrograms({ searchTerm = '', start = 0, limit = 20, sortOrder = 'dateDesc' }) {
  const user = getLocalStorageItem('limitless-user');
  const coachID = user?.user?.coachID;

  const [programs, setPrograms] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const sortMap = {
    alphabeticalAsc: 'programName:asc',
    alphabeticalDesc: 'programName:desc',
    dateAsc: 'createdAt:asc',
    dateDesc: 'createdAt:desc', 
  };

  const sortClause = `sort: ["${sortMap[sortOrder]}"]`;

  useEffect(() => {
    if (!coachID) return;

    const fetchPrograms = async () => {
      setIsLoading(true);
      setIsError(false);

      const isSearch = searchTerm.trim().length > 0;
      const paginationClause = isSearch
        ? 'pagination: { limit: 300 }'
        : `pagination: { start: ${start}, limit: ${limit} }`;

      const searchFilter = isSearch
        ? `programName: { containsi: "${searchTerm}" },`
        : '';

      const query = `
        query {
          programs(
            ${paginationClause},
            ${sortClause},
            filters: {
              ${searchFilter}
              created_by_coach: { id: { eq: ${coachID} } }
            }
          ) {
            data {
              id
              attributes {
                programName
                users {
                  data {
                    id
                  }
                }
                cover_image {
                  data {
                    attributes {
                      images {
                        data {
                          attributes {
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      try {
        const response = await axiosAuthFetch(API_GRAPHQL, { query }, 'POST');
        setPrograms(response.data.programs.data);
      } catch (err) {
        console.error(err);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPrograms();
  }, [coachID, searchTerm, start, limit, sortClause]);

  return { programs, isLoading, isError };
}
